import Vue from "vue";
import Router from "vue-router";
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import store from './store/index'
/* eslint-disable */
Vue.use(Router);
const routes = [{
    path: '*',
    redirect: '/page'
  },
  {
    name: 'login',
    component: () => import('./view/login'),
    meta: {
      title: '登录账号',
      tabbar: false,
      navbar: false,
      isShow: true,
    }
  },
  {
    name: 'openId',
    component: () => import('./view/openId'),
    meta: {
      title: '测试账号',
      tabbar: false,
      navbar: false,
      isShow: true,
    }
  },
  // {
  //   name: 'test1',
  //   component: () => import('./view/cart/test.vue'),
  //   meta: {
      
  //     tabbar: false,
  //     navbar: false,
  //     isShow: true,
  //   }
  // },
  {
    name: 'page',
    path: '/page',
    component: () => import('./view/page/index.vue'),
    meta: {
      title: '店铺首页',
      requiresAuth: true,
      tabbar: true,
      menuindex: 1,
      keepalive: true,
      isShow:true,
      isPageShow:true,
      isBack:false
    }
  },
  {
    name: 'cart',
    component: () => import('./view/cart'),
    meta: {
      title: '购物车',
      navbar: false,
      tabbar: true,
      menuindex: 3,
      requiresAuth: true,
      isShow:true
    }
  },
  {
    name: 'user',
    path: '/user',
    component: () => import('./view/user/index'),
    meta: {
      title: '会员中心',
      requiresAuth: true,
      tabbar: true,
      menuindex: 4,
      navbar: false,
      isShow:true
    }
  },
  // {
  //   name: 'test',
  //   path: '/test',
  //   component: () => import('./view/test/index'),
  //   meta: {
  //     title: '测试',
  //     navbar: false,
  //     isShow:true
  //   }
  // },
  // {
  //   name: 'player',
  //   component: () => import('./view/player/index'),
  //   meta: {
  //     title: '播放器',
  //     navbar: false,
  //     requiresAuth: true,
  //     keepalive: false,
  //     isShow:true
  //   }
  // },
  {
    name: 'getAvatar',
    component: () => import('./view/user/getAvatar/index'),
    meta: {
      meta: {
        title: '微信获取中',
        tabbar: false,
        navbar: false,
        isShow: true,
        requiresAuth: true
      }
    }
  },
  // {
  //   name: 'MallIndex',
  //   component: () => import('./view/PointsMall/MallIndex/index'),
  //   meta: {
  //     title: '积分商城',
  //     mallTabbar: true,
  //     navbar: false,
  //     requiresAuth: true,
  //     menuindex: 2,
  //     isShow:true
  //   }
  // },
  // {
  //   name: 'MallCenter',
  //   component: () => import('./view/PointsMall/MallCenter/index'),
  //   meta: {
  //     title: '积分中心',
  //     mallTabbar: true,
  //     navbar: false,
  //     requiresAuth: true,
  //     menuindex: 2,
  //     isShow: true,
  //   }
  // },
  // {
  //   name: 'MallDetail',
  //   component: () => import('./view/PointsMall/MallDetail/index'),
  //   meta: {
  //     title: '积分商品详情',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true,
  //     isShow:true
  //   }
  // },
  // {
  //   name: 'MallOrder',
  //   component: () => import('./view/PointsMall/MallOrder/index'),
  //   meta: {
  //     title: '订单中心',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true,
  //     isShow:true
  //   }
  // },
  // {
  //   name: 'MallOrderDetail',
  //   component: () => import('./view/PointsMall/MallOrder/detail'),
  //   meta: {
  //     title: '积分订单详情',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true,
  //     isShow:true
  //   }
  // },
  // {
  //   name: 'MallPurchase',
  //   component: () => import('./view/PointsMall/MallPurchase/index'),
  //   meta: {
  //     title: '支付页面',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true
  //   }
  // },
  // {
  //   name: 'Mallintegral',
  //   component: () => import('./view/PointsMall/Mallintegral/index'),
  //   meta: {
  //     title: '积分明细',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true
  //   }
  // },
  // {
  //   name: 'IntegralRule',
  //   component: () => import('./view/PointsMall/IntegralRule/index'),
  //   meta: {
  //     title: '积分规则',
  //     mallTabbar: false,
  //     navbar: false,
  //     requiresAuth: true
  //   }
  // },
  {
    name: 'packageList',
    component: () => import('./view/package/list'),
    meta: {
      title: '套餐包列表',
      tabbar: true,
      navbar: false,
      requiresAuth: true,
      isShow:true
    }
  },
  {
    name: 'package',
    component: () => import('./view/package/index'),
    meta: {
      title: '套餐包详情',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'goods',
    component: () => import('./view/goods'),
    meta: {
      title: '商品详情',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  // 测试
  // {
  //   name: 'goods',
  //   component: () => import('./view/goods/after'),
  //   meta: {
  //     title: '商品测试',
  //     tabbar: false,
  //     navbar: false,
  //     // requiresAuth: true
  //   }
  // },
  {
    name: 'activityMinPage',
    component: () => import('./view/activityMinPage'),
    meta: {
      title: '活动详情图',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'miniPage',
    component: () => import('./view/miniPage'),
    meta: {
      title: '商品介绍图',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'group',
    component: () => import('./view/group/index'),
    meta: {
      title: '商品分类',
      tabbar: true,
      menuindex: 2,
      keepalive: false,
      requiresAuth: true
    }
  },
  {
    name: 'search',
    component: () => import('./view/group/search'),
    meta: {
      title: '搜索',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'searchList',
    component: () => import('./view/group/searchList'),
    path: "/searchList",
    meta: {
      title: '搜索列表',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'groupList',
    component: () => import('./view/group/list'),
    meta: {
      title: '商品分类',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'groupChildList',
    component: () => import('./view/group/childList'),
    meta: {
      title: '商品子分类',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'goodslist',
    component: () => import('./view/goodslist'),
    meta: {
      title: '商品列表',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'shareCode',
    component: () => import('./view/user/shareCode'),
    meta: {
      title: '分享二维码',
      requiresAuth: true,
      tabbar: false,
      navbar: false,
    }
  },
  // 绑定用户二维码分享
  {
    name: 'commonShareCode',
    component: () => import('./view/user/commonShareCode'),
    meta: {
      title: '分享二维码',
      requiresAuth: true,
      tabbar: false,
      navbar: false,
    }
  },
  {
    name: 'like',
    component: () => import('./view/like/index'),
    meta: {
      title: '点赞',
      requiresAuth: true,
      tabbar: false,
      navbar: false,
    }
  },
  // {
  //   name: 'header',
  //   component: () => import('./components/headerFixed'),
  //   meta: {
  //     title: '顶部',
  //     tabbar: false,
  //     navbar: false
  //   }
  // },
  {
    name: 'cannotAccess',
    component: () => import('./components/cannotAccess'),
    meta: {
      title: '网站暂未开放',
      tabbar: false,
      navbar: false,
      isShow: true
    }
  },
  {
    name: 'frozen',
    component: () => import('./components/frozen'),
    meta: {
      title: '账号冻结',
      tabbar: false,
      navbar: false
    }
  },

  {
    name: 'Missing',
    component: () => import('./components/PageMissing'),
    meta: {
      title: '错误页',
      tabbar: false,
      navbar: false
    }
  },
  {
    name: 'loading',
    component: () => import('./components/loading/loading'),
    meta: {
      title: 'loading',
      tabbar: false,
      navbar: false,
    }
  },
  // {
  //   name: 'ConfettiEffect',
  //   component: () => import('./components/ConfettiEffect.vue'),
  //   meta: {
  //     title: 'ConfettiEffect',
  //     tabbar: false,
  //     navbar: false,
  //   }
  // },
  // {
  //   name: 'PrivacyAgreement',
  //   component: () => import('./components/PrivacyAgreement'),
  //   meta: {
  //     title: '隐私协议',
  //     tabbar: false,
  //     navbar: false,
  //   }
  // },
  {
    name: 'employeeToast',
    component: () => import('./components/employeeToast'),
    meta: {
      title: '弹窗',
      tabbar: false,
      navbar: false,
    }
  },
  {
    name: 'addBankCard',
    component: () => import('./view/bank/addBankCard'),
    meta: {
      title: '添加银行卡',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'bankPrivacy',
    component: () => import('./view/bank/bankPrivacy'),
    meta: {
      title: '协议声明',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },

  {
    name: 'detailBankCard',
    component: () => import('./view/bank/detailBankCard'),
    meta: {
      title: '银行卡详情',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'employeeMessage',
    component: () => import('./view/bank/employeeMessage'),
    meta: {
      // title: '绑定银行卡',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  
  {
    name: 'buyAgent',
    component: () => import('./view/buyAgent'),
    meta: {
      title: '代买人收货信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'AgentNickName',
    component: () => import('./view/buyAgent/nickName'),
    meta: {
      title: '代买人昵称列表',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'buyAgentAdd',
    component: () => import('./view/buyAgent/add.vue'),
    meta: {
      title: '新增代买人信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'buyAgentedit',
    component: () => import('./view/buyAgent/edit.vue'),
    meta: {
      title: '编辑代买人信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'chatlist',
    component: () => import('./view/chatlist'),
    meta: {
      title: '消息列表',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'shareCodeResult',
    component: () => import('./view/shareCodeResult'),
    meta: {
      title: '绑定页面',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'clerk',
    component: () => import('./view/manager/clerk'),
    meta: {
      title: '店员数量',
      requiresAuth: true,
      tabbar: false,
      navbar: false

    }
  },
  {
    name: 'managerList',
    component: () => import('./view/manager/list'),
    meta: {
      title: '我的店员列表',
      tabbar: false,
      navbar: false,
      requiresAuth: true,

    }
  },
  {
    name: 'managerSuccess',
    component: () => import('./view/manager/success'),
    meta: {
      title: '成功',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'manager',
    component: () => import('./view/manager/manager'),
    meta: {
      title: '我的店员',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'clerkMessage',
    component: () => import('./view/manager/message'),
    meta: {
      title: '店员信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'invitation',
    component: () => import('./view/invitation'),
    meta: {
      title: '邀请店员',
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'myShareCode',
    component: () => import('./view/myShareCode'),
    meta: {
      title: '我的分享',
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'myEmpShareCode',
    component: () => import('./view/myEmpShareCode'),
    meta: {
      title: '我的分享',
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'myStatistics',
    component: () => import('./view/myStatistics/update.vue'),
    meta: {
      title: '我的统计',
      navbar: false,
      requiresAuth: true,
    }
  },
 {
    name: 'maintenance',
    component: () => import('./view/maintenance'),
    meta: {
      title: '寻找服务人',
      navbar: false,
      requiresAuth: true,
    }
  },
  // {
  //   name: 'CustomerMaintenance',
  //   component: () => import('./view/CustomerMaintenance'),
  //   meta: {
  //     title: '寻找服务人',
  //     navbar: false,
  //     requiresAuth: true,
  //   }
  // },
  // {
  //   name: 'empInvitationCode',
  //   component: () => import('./view/invitation/empInvitationCode'),
  //   meta: {
  //     title: '测试扫码',
  //     requiresAuth: true,
  //   }
  // },
  {
    name: 'brokerage',
    component: () => import('./view/invitation/brokerage'),
    meta: {
      title: '佣金',
      requiresAuth: true,
    }
  },
  {
    name: 'profit',
    component: () => import('./view/invitation/profit'),
    meta: {
      title: '利润',
      requiresAuth: true,
    }
  },
  {
    name: 'brokerageList',
    component: () => import('./view/invitation/brokerageList'),
    meta: {
      title: '利润明细',
      requiresAuth: true,
    }
  },
  {
    name: 'codeShowPage',
    component: () => import('./view/user/codeShowPage/index'),
    meta: {
      title: '桃花三宝',
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'applyList',
    component: () => import('./view/user/apply'),
    meta: {
      title: '担保申请列表',
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'partnerList',
    component: () => import('./view/user/partnerList'),
    meta: {
      title: '店长列表',
      navbar: false,
      requiresAuth: true,
    }
  },
  // {
  //   name: 'clerkRegister',
  //   component: () => import('./view/invitation/register'),
  //   meta: {
  //     title: '店员注册',
  //     navbar: false
  //   }
  // },
  {
    name: 'userMessage',
    component: () => import('./view/invitation/message'),
    meta: {
      title: '申请店员信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  // {
  //   name: 'invitationProfile',
  //   component: () => import('./view/invitation/profile'),
  //   meta: {
  //     title: '上传资料',
  //     requiresAuth: false,
  //     tabbar: false,
  //     navbar: true
  //   }
  // },
  // {
  //   name: 'upload',
  //   component: () => import('./view/invitation/upload'),
  //   meta: {
  //     title: '上传身份信息',
  //     tabbar: false,
  //     navbar: false
  //   }
  // },
  {
    name: 'invitationSuccess',
    component: () => import('./view/invitation/invitationSuccess'),
    meta: {
      title: '申请状态',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'setting',
    component: () => import('./view/setting/avar'),
    meta: {
      title: '设置',
      tabbar: false,
      requiresAuth: true,
      navbar: false,
    }
  },
  // {
  //   name: 'coupons',
  //   component: () => import('./view/coupons/index'),
  //   meta: {
  //     title: '优惠卷',
  //     tabbar: false,
  //     navbar: false,
  //     requiresAuth: true,
  //   }
  // },

  {
    name: 'address/addressDefault',
    component: () => import('./view/user/address/addressDefault'),
    path: "/address/addressDefault",
    meta: {
      title: '修改地址',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
      // keepalive: true
    }
  },
  {
    name: 'addresslist',
    component: () => import('./view/address/index.vue'),
    meta: {
      title: '我的地址',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'myAddress',
    component: () => import('./view/user/address/index.vue'),
    meta: {
      title: '我的地址',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'addressedit',
    component: () => import('./view/address/edit.vue'),
    meta: {
      title: '编辑/新增地址',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'checkout',
    path: '/checkout',
    component: () => import('./view/checkout/index'),
    meta: {
      title: '待付款订单',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'checkoutCoupons',
    path: '/checkout/coupons',
    component: () => import('./view/checkout/coupons'),
    meta: {
      title: '订单优惠',
      tabbar: false,
      keepalive: false,
      requiresAuth: true,
    }
  },
  {
    name: 'payResult',
    // path: '/payResult',
    component: () => import('./view/payResult'),
    meta: {
      title: '支付结果',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'myorder',
    component: () => import('./view/order/list'),
    meta: {
      title: '我的订单',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'orderDetail',
    component: () => import('./view/order/detail'),
    path: '/orderdetail',
    meta: {
      title: '订单详情',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'refundlist',
    component: () => import('./view/order/refundlist'),
    meta: {
      title: '退款/售后',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'refund',
    component: () => import('./view/order/refund'),
    meta: {
      title: '申请退款',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  {
    name: 'express',
    component: () => import('./view/express/index'),
    path: '/express',
    meta: {
      title: '物流信息',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
      // keepalive: true
    }
  },

  // {
  //   name: 'redirect-wx',
  //   path: '/redirect-wx',
  //   beforeEnter: (to, from, next) => {
  //     var state = "http://192.168.1.141:8080/#" + from.query.redirect;
  //     window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7f53588fbd8d02fe&redirect_uri=http%3a%2f%2fservice.aggregator.taohualian168.net%2fapi%2fv1%2fWxRedirectPage&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
  //   }
  // },
  {
    name: 'redirect',
    component: () => import('./view/redirect/redirect'),
    meta: {
      title: '微信登录中',
      tabbar: false,
      navbar: false,
      isShow: true
    }
  },
  {
    name: 'bind',
    path: '/bind',
    component: () => import('./view/invitation/bind'),
    meta: {
      title: '绑定',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'employeeCode',
    path: '/employeeCode',
    component: () => import('./view/invitation/employeeCode'),
    meta: {
      title: '分享码失效',
      tabbar: false,
      navbar: false,
      requiresAuth: true
    }
  },
  {
    name: 'bindStatus',
    component: () => import('./view/invitation/bindStatus'),
    meta: {
      title: '绑定结果',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
    //win 我的资产
    {
      name: 'myProperty',
      component: () => import('./view/myProperty'),
      meta: {
        title: '我的资产',
        navbar: false,
        requiresAuth: true,
      }
    },
  //win 我的库存码
  {
    name: 'inventoryCode',
    component: () => import('./view/inventoryCode/index'),
    meta: {
      title: '我的库存码',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
    // win 我的核销码
    // {
    //   name: 'orderCode',
    //   component: () => import('./view/orderCode/index'),
    //   meta: {
    //     title: '我的核销码',
    //     tabbar: false,
    //     navbar: false,
    //     requiresAuth: true,
    //   }
    // },
  //lhy 新增申请店长
  {
    name: 'shopkeeper',
    component: () => import('./view/shopkeeper/index'),
    meta: {
      title: '申请店长',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  //lhy 新增 贷款申请
  {
    name: 'loan',
    component: () => import('./view/loan/index'),
    meta: {
      title: '货款',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  //lhy 新增 代理所申请
  {
    name: 'agent',
    component: () => import('./view/agent/index'),
    meta: {
      title: '代理商',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  //lhy 新增 代理所申请
  {
    name: 'application',
    component: () => import('./view/application/index'),
    meta: {
      title: '申请审核',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  //lhy 新增 公司服务
  {
    name: 'compamyServe',
    component: () => import('./view/companyServe/index'),
    meta: {
      title: '公司服务',
      tabbar: false,
      navbar: false,
      requiresAuth: true,
    }
  },
  //lhy 新增 我的雇佣 25年3月20关闭入口
    // {
    //   name: 'hire',
    //   component: () => import('./view/user/hire/index'),
    //   meta: {
    //     title: '我的雇佣',
    //     tabbar: false,
    //     navbar: false,
    //     requiresAuth: true,
    //   }
    // },
    //lhy 新增 我的雇佣申请 25年3月20关闭入口
    // {
    //   name: 'hireAplication',
    //   component: () => import('./view/user/hire/hireAplication.vue'),
    //   meta: {
    //     title: '雇佣邀请',
    //     tabbar: false,
    //     navbar: false,
    //     requiresAuth: true,
    //   }
    // },
    //  //lhy 新增 我的雇佣申请
    //  {
    //   name: 'hireInvite',
    //   component: () => import('./view/user/hire/hireInvite.vue'),
    //   meta: {
    //     title: '雇佣邀请',
    //     tabbar: false,
    //     navbar: false,
    //     requiresAuth: true,
    //   }
    // },
    {
      name: 'performance',
      component: () => import('./view/user/performance/index'),
      meta: {
        title: '我的业绩',
        tabbar: false,
        navbar: false,
        requiresAuth: true,
      }
    },
    {
      name: 'salesPerformance',
      component: () => import('./view/salesPerformance/index'),
      meta: {
        title: '销售业绩',
        tabbar: false,
        navbar: false,
        requiresAuth: true,
      }
    },
    {
      name: 'ownerApproval',
      component: () => import('./view/ownerApproval/index'),
      meta: {
        title: '店长审批',
        tabbar: false,
        navbar: false,
        requiresAuth: true, 
      }
    },
    {
      name: 'approvalSales',
      component: () => import('./view/approvalSales/index'),
      meta: { 
        title: '销售审批',
        tabbar: false,
        navbar: false,
        requiresAuth: true,
      }
    },
    {
      name: 'ownerApply',
      component: () => import('./view/ownerApply/index'),
      meta: {
        title: '店长申请', 
        tabbar: false,
        navbar: false,
        requiresAuth: true,
      }
    },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({
  mode: 'history', 
  routes
});

import VueLogger from 'vuejs-logger';
const isProduction = process.env.NODE_ENV === 'production';
const debugOptions = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, debugOptions);

router.beforeEach((to, from, next) => {
  // if (to.path == "/cart") {
  //   if (from.path == "/goods") {
  //     to.meta.navbar = true;
  //   } else {
  //     to.meta.navbar = true;
  //   }
  // }
//  if (to.path == "/") {
//     if (from.path == "/goods") {
//       to.meta.isBack = true;
//     } else {
//       to.meta.isBack = false;
//     }
//   }
  let userInfo = store.getters.userInfo;
  // let cartInfo = store.getters.cartInfo;
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  if (to.meta.progress !== undefined) {
    let meta = to.meta.progress;
    router.app.$Progress.parseMeta(meta);
  }

  router.app.$Progress.start();
  if (to.meta.requiresAuth) {
    if (userInfo && userInfo.token && userInfo.isLogin) {
        next();
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next();
  }
});
router.afterEach((to, from) => {
  //  finish the progress bar
  router.app.$Progress.finish();
});

export {
  router
};